import { takeLatest, takeEvery, call, put } from 'redux-saga/effects';

import {
  getUsers as getUsersApi,
  getOneUser as getOneUserApi,
  getLimitedUsers as getLimitedUsersApi,
  deleteUser as deleteUserApi,
} from '../../services';
import { displayNotification, checkOnline, getNotification } from '../notifications';
import {
  REQUEST_USERS,
  REQUEST_LIMITED_USERS,
  REQUEST_USER,
  DELETE_USER,
  receiveUser,
  receiveUsers,
  receiveLimitedUsers,
} from './actions';
import { requestMembers } from '../auth/actions';

export function* doRequestUser(action) {
  try {
    const { oid } = action;
    const user = yield call(getOneUserApi, oid);

    yield put(receiveUser(oid, user));
  } catch (e) {
    console.error('Unable to fetch user: ', e);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('getOneUser', 'error')()));
  }
}

export function* doRequestUsers() {
  try {
    const { values: users } = yield call(getUsersApi, { limit: 0 });
    yield put(receiveUsers(users.reduce((acc, user) => ({ ...acc, [user.id]: user }), {})));
  } catch (e) {
    console.error('Unable to fetch users: ', e);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('getUsers', 'error')()));
  }
}

export function* doRequestLimitedUsers(action) {
  try {
    const { siteId } = action;
    const { values: users } = yield call(getLimitedUsersApi, { site: siteId });
    yield put(receiveLimitedUsers(users));
  } catch (e) {
    console.error('Unable to fetch users: ', e);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('getUsers', 'error')()));
  }
}

export function* doDeleteUser(action) {
  try {
    const { oid } = action;
    yield call(deleteUserApi, oid);
    yield put(requestMembers(undefined, true));
    yield put(displayNotification(getNotification('deleteUser', 'success')(oid)));
  } catch (e) {
    console.error('Unable to delete user: ', e?.message);
    yield call(checkOnline);
    yield put(displayNotification(getNotification('deleteUser', 'error')(e?.message)));
  }
}

export const sagas = [
  takeEvery(REQUEST_USER, doRequestUser),
  takeLatest(REQUEST_USERS, doRequestUsers),
  takeLatest(REQUEST_LIMITED_USERS, doRequestLimitedUsers),
  takeLatest(DELETE_USER, doDeleteUser),
];
